// extracted by mini-css-extract-plugin
export var breadcrumb = "_11-2";
export var breadcrumbArrow = "_11-3";
export var breadcrumbs = "_11-0";
export var link = "_11-4";
export var small = "_11-1";